import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Badge, Button, Dropdown } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../../store/rootStore';
import styles from './Dropdown.module.scss';
import { NotificationsList } from '../..';
const NotificationDropdown = () => {
    var _a;
    const { notificationsStore } = useStore();
    const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const handleNotificationClick = (id) => {
        history.push(`/notifications/${id}`);
        setIsOpen(false);
    };
    const handleSeeAllClick = () => {
        history.push('/notifications');
        setIsOpen(false);
    };
    return (React.createElement(Dropdown, { open: isOpen, onOpenChange: setIsOpen, dropdownRender: () => (React.createElement("div", { className: styles.dropdown },
            React.createElement(NotificationsList, { onNotificationClick: handleNotificationClick, onSeeAllClick: handleSeeAllClick }))), placement: "bottomRight", trigger: ['click'] },
        React.createElement(Badge, { count: (_a = notificationsStore.notifications) === null || _a === void 0 ? void 0 : _a.filter((notification) => !notification.read).length, className: styles.badge },
            React.createElement(Button, { shape: "circle", className: styles.button },
                React.createElement(BellOutlined, null)))));
};
export default observer(NotificationDropdown);
